// src/components/Header.jsx - MODERN REDESIGN
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ApiService from '../services/apiService';

var isGJ = true;

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [showAccountDropdown, setShowAccountDropdown] = useState(false);
  const [isLoadingProfile, setIsLoadingProfile] = useState(false);
  const [logo, setLogo] = useState("/logoLe.png");


    
  useEffect(() => {
    const domain = window.location.hostname;
    if (domain.includes("gojuris.ai")) {
      isGJ = true;
      setLogo("/logo.png");
    }

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    checkAuthStatus();
  }, [location.pathname]);

  const checkAuthStatus = () => {
    const authenticated = ApiService.isAuthenticated();
    setIsAuthenticated(authenticated);

    if (authenticated) {
      loadUserProfile();
    }
  };

  const loadUserProfile = async () => {
    setIsLoadingProfile(true);
    try {
      const storedEmail = localStorage.getItem('userEmail');
      const storedUserData = localStorage.getItem('userData');

      let profileData = {
        email: storedEmail || 'user@legaleagle.com',
        displayName: 'Legal User',
        username: storedEmail ? storedEmail.split('@')[0] : 'user'
      };

      if (storedUserData) {
        try {
          const parsedData = JSON.parse(storedUserData);
          profileData = { ...profileData, ...parsedData };
        } catch (e) {
          console.warn('Failed to parse stored user data');
        }
      }

      if (storedEmail) {
        try {
          const response = await ApiService.getUserProfile();
          if (response && response.email) {
            profileData = {
              email: response.email,
              displayName: response.name || response.displayName || response.username || storedEmail.split('@')[0],
              username: response.username || storedEmail.split('@')[0],
              ...response
            };
          }
        } catch (apiError) {
          console.warn('Failed to fetch user profile from API:', apiError.message);
        }
      }

      setUserProfile(profileData);
    } catch (error) {
      console.error('Failed to load user profile:', error);
      setUserProfile({
        email: 'user@legaleagle.com',
        displayName: 'Legal User',
        username: 'user'
      });
    } finally {
      setIsLoadingProfile(false);
    }
  };

  const handleSignOut = async () => {
    try {
      setShowAccountDropdown(false);
      await ApiService.logout();
      setIsAuthenticated(false);
      setUserProfile(null);
      setIsLoadingProfile(false);
      navigate('/login');
    } catch (error) {
      console.error('Sign out error:', error);
      try {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('expiresAt');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('userData');
        setIsAuthenticated(false);
        setUserProfile(null);
        navigate('/login');
      } catch (clearError) {
        console.error('Failed to clear auth data:', clearError);
      }
    }
  };

  const handleDropdownItemClick = async (action) => {
    setShowAccountDropdown(false);

    switch (action) {
      case 'dashboard':
        navigate('/dashboard');
        break;
      case 'profile':
        navigate('/dashboard');
        break;
      case 'history':
        navigate('/dashboard');
        break;
      case 'signout':
        await handleSignOut();
        break;
      default:
        break;
    }
  };

  const getEmail = () => {
    if (userProfile?.email) return userProfile.email;
    const storedEmail = localStorage.getItem('userEmail');
    return storedEmail || 'user@legaleagle.com';
  };

  const getDisplayName = () => {
    if (userProfile?.displayName) return userProfile.displayName;
    if (userProfile?.name) return userProfile.name;
    if (userProfile?.username) return userProfile.username;
    const email = getEmail();
    return email.split('@')[0];
  };

  const getUserInitials = () => {
    const name = getDisplayName();
    const nameParts = name.split(' ');
    if (nameParts.length >= 2) {
      return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const toggleOffcanvas = () => {
    setIsOffcanvasOpen(!isOffcanvasOpen);
    document.body.style.overflow = !isOffcanvasOpen ? 'hidden' : 'unset';
  };

  const closeOffcanvas = () => {
    setIsOffcanvasOpen(false);
    document.body.style.overflow = 'unset';
  };

  const toggleTheme = () => {
    const newTheme = !isDarkMode;
    setIsDarkMode(newTheme);
    document.documentElement.setAttribute('data-bs-theme', newTheme ? 'dark' : 'light');
    localStorage.setItem('theme', newTheme ? 'dark' : 'light');
  };

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      const isDark = savedTheme === 'dark';
      setIsDarkMode(isDark);
      document.documentElement.setAttribute('data-bs-theme', savedTheme);
    }
  }, []);

  const scrollToSection = (sectionId) => {
    if (location.pathname === '/search') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const headerOffset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        const headerOffset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
    closeOffcanvas();
  };

  const navigateToHome = () => {
    if (location.pathname === '/') {
      const heroElement = document.getElementById('hero');
      if (heroElement) {
        const headerOffset = 120;
        const elementPosition = heroElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    } else {
      navigate('/');
    }
    closeOffcanvas();
  };

  const navigateToSearch = () => {
    navigate('/search');
    closeOffcanvas();
  };

  const navigateToLogin = () => {
    navigate('/login');
    closeOffcanvas();
  };

  const navigateToDashboard = () => {
    navigate('/dashboard');
    closeOffcanvas();
    setShowAccountDropdown(false);
  };

  const navigateToSubscriptions = () => {
    navigate('/pricing');
    closeOffcanvas();
  };

  const navigateToLatest = () => {
    navigate('/Latest-Law');
    closeOffcanvas();
  };

  const handleContactClick = (e) => {
    e.preventDefault();
    scrollToSection('contact');
  };

  return (
    <>
      {/* Announcement Banner */}
      <div className="modern-announcement-banner">
        <div className="announcement-content">
          <div className="announcement-icon">
            <i className="bx bx-bolt-circle"></i>
          </div>
          <p className="announcement-text">
            <strong>{isGJ ? 'LJSoft Online' : 'LJSoft Online'}</strong> is now Fast and Reliable
          </p>
          <div className="announcement-badge">NEW</div>
        </div>
      </div>

      {/* Main Header */}
      <header className={`modern-header ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <div className="header-content">
            {/* Logo */}
            <div className="header-logo" onClick={navigateToHome}>
              <img src={logo} alt="Logo" className="logo-image" />
            </div>

            {/* Desktop Navigation */}
            <nav className="desktop-nav">
              <button
                className={`nav-link-modern ${location.pathname === '/' ? 'active' : ''}`}
                onClick={navigateToHome}
              >
                HOME
              </button>
              <button
                className="nav-link-modern"
                onClick={() => scrollToSection('about')}
              >
                WHY US
              </button>
              <button
                className="nav-link-modern"
                onClick={() => scrollToSection('video-section')}
              >
                COVERAGE
              </button>
              <button
                className="nav-link-modern"
                onClick={navigateToLatest}
              >
                LATEST
              </button>
              <button
                className="nav-link-modern"
                onClick={navigateToSubscriptions}
              >
                SUBSCRIPTIONS
              </button>
            </nav>

            {/* Right Actions */}
            <div className="header-actions">
              {/* Authentication */}
              {isAuthenticated ? (
                <div className="user-profile-wrapper">
                  <button
                    className="user-profile-btn"
                    onClick={() => setShowAccountDropdown(!showAccountDropdown)}
                  >
                    <div className="user-avatar">
                      {getUserInitials()}
                    </div>
                    <span className="user-name">{getDisplayName()}</span>
                    <i className={`bx bx-chevron-down ${showAccountDropdown ? 'rotate' : ''}`}></i>
                  </button>

                  {/* Dropdown Menu */}
                  {showAccountDropdown && (
                    <div className="user-dropdown">
                      <div className="dropdown-header">
                        <div className="user-avatar-large">
                          {getUserInitials()}
                        </div>
                        <div className="user-info">
                          <div className="user-name-large">{getDisplayName()}</div>
                          <div className="user-email">{getEmail()}</div>
                        </div>
                      </div>

                      <div className="dropdown-divider"></div>

                      <button
                        className="dropdown-item"
                        onClick={() => handleDropdownItemClick('dashboard')}
                      >
                        <i className="bx bx-grid-alt"></i>
                        <span>Dashboard</span>
                      </button>

                      <button
                        className="dropdown-item"
                        onClick={() => handleDropdownItemClick('profile')}
                      >
                        <i className="bx bx-user"></i>
                        <span>Profile</span>
                      </button>

                      <button
                        className="dropdown-item"
                        onClick={() => handleDropdownItemClick('history')}
                      >
                        <i className="bx bx-history"></i>
                        <span>Search History</span>
                      </button>

                      <div className="dropdown-divider"></div>

                      <button
                        className="dropdown-item danger"
                        onClick={() => handleDropdownItemClick('signout')}
                      >
                        <i className="bx bx-log-out"></i>
                        <span>Sign Out</span>
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <button
                  onClick={navigateToLogin}
                  className="login-btn-modern"
                >
                  <i className="bx bx-user"></i>
                  <span>LOGIN</span>
                </button>
              )}

              {/* Mobile Menu Toggle */}
              <button
                className="mobile-menu-toggle"
                onClick={toggleOffcanvas}
                aria-label="Toggle menu"
              >
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Offcanvas Menu */}
      <div className={`mobile-offcanvas ${isOffcanvasOpen ? 'show' : ''}`}>
        <div className="offcanvas-header-modern">
          <img src={logo} alt="Logo" className="offcanvas-logo" />
          <button
            className="close-btn"
            onClick={closeOffcanvas}
            aria-label="Close menu"
          >
            <i className="bx bx-x"></i>
          </button>
        </div>

        <div className="offcanvas-body-modern">
          {/* Mobile Navigation */}
          <nav className="mobile-nav">
            <button
              className={`mobile-nav-link ${location.pathname === '/' ? 'active' : ''}`}
              onClick={navigateToHome}
            >
              <i className="bx bx-home"></i>
              <span>Home</span>
            </button>

            <button
              className="mobile-nav-link"
              onClick={() => scrollToSection('about')}
            >
              <i className="bx bx-star"></i>
              <span>Why Us</span>
            </button>

            <button
              className="mobile-nav-link"
              onClick={() => scrollToSection('video-section')}
            >
              <i className="bx bx-shield"></i>
              <span>Coverage</span>
            </button>

            <button
              className="mobile-nav-link"
              onClick={() => scrollToSection('services')}
            >
              <i className="bx bx-news"></i>
              <span>Latest</span>
            </button>

            <button
              className="mobile-nav-link"
              onClick={navigateToSubscriptions}
            >
              <i className="bx bx-credit-card"></i>
              <span>Subscriptions</span>
            </button>
          </nav>

          {/* Mobile User Section */}
          <div className="mobile-user-section">
            {isAuthenticated ? (
              <div className="mobile-user-card">
                <div className="user-avatar-mobile">
                  {getUserInitials()}
                </div>
                <div className="user-info-mobile">
                  <div className="user-name-mobile">{getDisplayName()}</div>
                  <div className="user-email-mobile">{getEmail()}</div>
                </div>
                <button
                  className="mobile-signout-btn"
                  onClick={() => handleDropdownItemClick('signout')}
                >
                  <i className="bx bx-log-out"></i>
                </button>
              </div>
            ) : (
              <button
                onClick={navigateToLogin}
                className="mobile-login-btn"
              >
                <i className="bx bx-user"></i>
                <span>Login</span>
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Backdrop */}
      {isOffcanvasOpen && (
        <div
          className="offcanvas-backdrop"
          onClick={closeOffcanvas}
        ></div>
      )}

      {/* Account dropdown backdrop */}
      {showAccountDropdown && (
        <div
          className="dropdown-backdrop"
          onClick={() => setShowAccountDropdown(false)}
        ></div>
      )}

      <style jsx>{`
        /* ============================================
           ANNOUNCEMENT BANNER
        ============================================ */
        .modern-announcement-banner {
          background: linear-gradient(135deg, #E91E63 0%, #E91E64 50%, #c41849 100%);
          padding: 12px 0;
          position: relative;
          overflow: hidden;
        }

        .modern-announcement-banner::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg width="100" height="100" xmlns="http://www.w3.org/2000/svg"><defs><pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse"><circle cx="2" cy="2" r="1" fill="white" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
          pointer-events: none;
        }

        .announcement-content {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          position: relative;
          z-index: 1;
        }

        .announcement-icon {
          width: 28px;
          height: 28px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 18px;
          animation: pulse-icon 2s ease-in-out infinite;
        }

        @keyframes pulse-icon {
          0%, 100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
          }
          50% {
            transform: scale(1.05);
            box-shadow: 0 0 0 8px rgba(255, 255, 255, 0);
          }
        }

        .announcement-text {
          color: white;
          margin: 0;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 0.3px;
        }

        .announcement-badge {
          background: white;
          color: #c41849;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.5px;
          animation: badge-bounce 2s ease-in-out infinite;
        }

        @keyframes badge-bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-3px);
          }
        }

        /* ============================================
           MAIN HEADER
        ============================================ */
        .modern-header {
          background: white;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
          position: sticky;
          top: 0;
          z-index: 10000;
          transition: all 0.3s ease;
        }

        .modern-header.scrolled {
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        }

        .header-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px 0;
        }

        /* Logo */
        .header-logo {
          cursor: pointer;
          transition: transform 0.3s ease;
        }

        .header-logo:hover {
          transform: scale(1.05);
        }

        .logo-image {
          height: 60px;
          width: auto;
          max-width: 260px;
        }

        /* Desktop Navigation */
        .desktop-nav {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .nav-link-modern {
          background: none;
          border: none;
          color: #4a5568;
          font-size: 14px;
          font-weight: 600;
          padding: 10px 20px;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s ease;
          letter-spacing: 0.3px;
          position: relative;
        }

        .nav-link-modern::before {
          content: '';
          position: absolute;
          bottom: 8px;
          left: 50%;
          transform: translateX(-50%) scaleX(0);
          width: 30px;
          height: 3px;
          background: linear-gradient(135deg, #E91E63, #c41849);
          border-radius: 2px;
          transition: transform 0.3s ease;
        }

        .nav-link-modern:hover {
          color: #E91E63;
          background: rgba(245, 166, 35, 0.05);
        }

        .nav-link-modern:hover::before {
          transform: translateX(-50%) scaleX(1);
        }

        .nav-link-modern.active {
          color: #c41849;
          background: linear-gradient(135deg, rgba(245, 166, 35, 0.1), rgba(233, 30, 99, 0.1));
        }

        .nav-link-modern.active::before {
          transform: translateX(-50%) scaleX(1);
        }

        /* Header Actions */
        .header-actions {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        /* Login Button */
        .login-btn-modern {
          display: flex;
          align-items: center;
          gap: 8px;
          background: linear-gradient(135deg, #E91E63 0%, #c41849 100%);
          color: white;
          border: none;
          padding: 12px 24px;
          border-radius: 12px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(245, 166, 35, 0.3);
          letter-spacing: 0.5px;
        }

        .login-btn-modern:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(245, 166, 35, 0.4);
        }

        .login-btn-modern i {
          font-size: 18px;
        }

        /* User Profile */
        .user-profile-wrapper {
          position: relative;
        }

        .user-profile-btn {
          display: flex;
          align-items: center;
          gap: 10px;
          background: white;
          border: 2px solid #f0f0f0;
          padding: 8px 16px 8px 8px;
          border-radius: 50px;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .user-profile-btn:hover {
          border-color: #E91E63;
          box-shadow: 0 4px 15px rgba(245, 166, 35, 0.2);
        }

        .user-avatar {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: linear-gradient(135deg, #E91E63, #c41849);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 14px;
          font-weight: 700;
        }

        .user-name {
          font-size: 14px;
          font-weight: 600;
          color: #2d3748;
          max-width: 120px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .user-profile-btn i {
          font-size: 18px;
          color: #a0aec0;
          transition: transform 0.3s ease;
        }

        .user-profile-btn i.rotate {
          transform: rotate(180deg);
        }

        /* User Dropdown */
        .user-dropdown {
          position: absolute;
          top: calc(100% + 12px);
          right: 0;
          width: 280px;
          background: white;
          border-radius: 16px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
          padding: 16px;
          z-index: 1001;
          animation: dropdownSlideIn 0.3s ease;
        }

        @keyframes dropdownSlideIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .dropdown-header {
          display: flex;
          align-items: center;
          gap: 12px;
          padding-bottom: 16px;
        }

        .user-avatar-large {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: linear-gradient(135deg, #E91E63, #c41849);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 18px;
          font-weight: 700;
          flex-shrink: 0;
        }

        .user-info {
          flex: 1;
          min-width: 0;
        }

        .user-name-large {
          font-size: 16px;
          font-weight: 700;
          color: #2d3748;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .user-email {
          font-size: 13px;
          color: #718096;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .dropdown-divider {
          height: 1px;
          background: #e2e8f0;
          margin: 12px 0;
        }

        .dropdown-item {
          display: flex;
          align-items: center;
          gap: 12px;
          width: 100%;
          padding: 12px;
          background: none;
          border: none;
          border-radius: 10px;
          cursor: pointer;
          transition: all 0.2s ease;
          text-align: left;
        }

        .dropdown-item:hover {
          background: rgba(245, 166, 35, 0.1);
        }

        .dropdown-item i {
          font-size: 20px;
          color: #E91E63;
          width: 20px;
        }

        .dropdown-item span {
          font-size: 14px;
          font-weight: 500;
          color: #2d3748;
        }

        .dropdown-item.danger:hover {
          background: rgba(239, 68, 68, 0.1);
        }

        .dropdown-item.danger i {
          color: #ef4444;
        }

        .dropdown-item.danger span {
          color: #ef4444;
        }

        /* Mobile Menu Toggle */
        .mobile-menu-toggle {
          display: none;
          flex-direction: column;
          gap: 4px;
          background: none;
          border: none;
          padding: 8px;
          cursor: pointer;
        }

        .hamburger-line {
          width: 24px;
          height: 2px;
          background: #2d3748;
          border-radius: 2px;
          transition: all 0.3s ease;
        }

        /* ============================================
           MOBILE OFFCANVAS
        ============================================ */
        .mobile-offcanvas {
          position: fixed;
          top: 0;
          right: -100%;
          width: 300px;
          height: 100vh;
          background: white;
          z-index: 1002;
          transition: right 0.3s ease;
          box-shadow: -5px 0 20px rgba(0, 0, 0, 0.1);
        }

        .mobile-offcanvas.show {
          right: 0;
        }

        .offcanvas-header-modern {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 20px;
          border-bottom: 1px solid #e2e8f0;
        }

        .offcanvas-logo {
          height: 40px;
          width: auto;
        }

        .close-btn {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: #f7fafc;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .close-btn:hover {
          background: #e2e8f0;
        }

        .close-btn i {
          font-size: 24px;
          color: #2d3748;
        }

        .offcanvas-body-modern {
          padding: 20px;
          height: calc(100vh - 80px);
          overflow-y: auto;
        }

        /* Mobile Navigation */
        .mobile-nav {
          display: flex;
          flex-direction: column;
          gap: 8px;
          margin-bottom: 24px;
        }

        .mobile-nav-link {
          display: flex;
          align-items: center;
          gap: 12px;
          width: 100%;
          padding: 14px 16px;
          background: none;
          border: none;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.2s ease;
          text-align: left;
        }

        .mobile-nav-link:hover {
          background: rgba(245, 166, 35, 0.1);
        }

        .mobile-nav-link.active {
          background: linear-gradient(135deg, rgba(245, 166, 35, 0.1), rgba(233, 30, 99, 0.1));
        }

        .mobile-nav-link i {
          font-size: 20px;
          color: #E91E63;
          width: 20px;
        }

        .mobile-nav-link span {
          font-size: 15px;
          font-weight: 600;
          color: #2d3748;
        }

        /* Mobile User Section */
        .mobile-user-section {
          margin-top: auto;
          padding-top: 20px;
          border-top: 1px solid #e2e8f0;
        }

        .mobile-user-card {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 16px;
          background: linear-gradient(135deg, rgba(245, 166, 35, 0.05), rgba(233, 30, 99, 0.05));
          border-radius: 12px;
        }

        .user-avatar-mobile {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: linear-gradient(135deg, #E91E63, #c41849);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 16px;
          font-weight: 700;
          flex-shrink: 0;
        }

        .user-info-mobile {
          flex: 1;
          min-width: 0;
        }

        .user-name-mobile {
          font-size: 15px;
          font-weight: 700;
          color: #2d3748;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .user-email-mobile {
          font-size: 12px;
          color: #718096;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .mobile-signout-btn {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: white;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .mobile-signout-btn:hover {
          background: #fee;
        }

        .mobile-signout-btn i {
          font-size: 18px;
          color: #ef4444;
        }

        .mobile-login-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          width: 100%;
          padding: 14px;
          background: linear-gradient(135deg, #E91E63, #c41849);
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .mobile-login-btn:hover {
          box-shadow: 0 4px 15px rgba(245, 166, 35, 0.3);
        }

        /* Backdrops */
        .offcanvas-backdrop,
        .dropdown-backdrop {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          z-index: 999;
          animation: fadeIn 0.3s ease;
        }

        .dropdown-backdrop {
          z-index: 1000;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        /* ============================================
           RESPONSIVE
        ============================================ */
        @media (max-width: 991px) {
          .desktop-nav {
            display: none;
          }

          .mobile-menu-toggle {
            display: flex;
          }

          .login-btn-modern {
            padding: 10px 16px;
            font-size: 13px;
          }

          .user-name {
            display: none;
          }
        }

        @media (max-width: 767px) {
          .announcement-text {
            font-size: 12px;
          }

          .announcement-badge {
            font-size: 10px;
            padding: 3px 10px;
          }

          .header-content {
            padding: 12px 0;
          }

          .logo-image {
            height: 40px;
          }

          .login-btn-modern span {
            display: none;
          }

          .login-btn-modern {
            padding: 10px;
            border-radius: 50%;
            width: 40px;
            height: 40px;
          }
        }
      `}</style>
    </>
  );
};

export default Header;